import { useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";

export function useCatalogTab() {
  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const createModalRef = useRef<ModalRef>(null);
  const editModalRef = useRef<ModalRef>(null);

  const params = getQueryParams();
  const filters = params.catalog_search ? { search: params.catalog_search } : {};

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<IntegrationCatalog>({
    resource: "v1/integration_admin",
    filters,
    sorters: { ordering: "-agreements_count" },
  });

  return {
    rows,
    loading,
    tableProps,
    createModalRef,
    editModalRef,
    refetch,
    translate,
  };
}
